/**
 * What changed in the app, for the person reading (D-731).
 *
 * The server decides which entries she sees - one answer for the dialog, the
 * screen and the bell (A-17) - so nothing here filters.
 */
export type WhatsNewEntry = {
  number: number
  /** The studio calendar date it was written for (D-68). */
  released: string
  title: string
  body: string
  whereLabel: string | null
  wherePath: string | null
}

/** Every entry she matches, seen or not, newest first. */
export async function fetchWhatsNew(): Promise<WhatsNewEntry[]> {
  const res = await fetch('/api/whats-new')
  if (!res.ok) throw new Error(`Could not load what's new (${res.status})`)
  return res.json()
}

/**
 * She dismissed these. The server moves her marker to the highest of them - never
 * to the newest in the file, which she may not have been shown.
 */
export async function markWhatsNewSeen(numbers: number[]): Promise<void> {
  const res = await fetch('/api/whats-new/seen', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ numbers }),
  })
  if (!res.ok) throw new Error(`Could not mark what's new as seen (${res.status})`)
}
